import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { TransactionService } from '../services/transaction.service';
import { finalize } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
@Component({
  selector:'app-transactionsHistory',
  standalone:true,
  imports:[CommonModule],
  template:`
    <div class="spinner-container" *ngIf="isLoadingPageContent">
      <span class="spinner"></span>
    </div>
    <div *ngIf="showPageContent">
      <!-- TRANSACTION DETAILS -->
      <div *ngIf="!selectedTransaction">
        <div class="section-title">
          Transaction History
        </div>
        <div class="line-segment">
          <div
            *ngFor="let m of transactionMonths"
            [class.selected]="selectedMonth === m.month"
            (click)="selectMonth(m)">
            {{ m.month }}
          </div>
        </div>
        
        <div class="transactionHistory-summary">
          <div class="transactionHistory-summary-box">
            <div class="transactionHistory-summary-icon in">↓</div>
            <div>
              <div class="transactionHistory-summary-label">Money In</div>
              <div class="transactionHistory-summary-value">R{{moneyIn}}</div>
            </div>
          </div>
          <div class="transactionHistory-summary-box">
            <div>
              <div class="transactionHistory-summary-label">Money Out</div>
              <div class="transactionHistory-summary-value">R{{moneyOut}}</div>
            </div>
            <div class="transactionHistory-summary-icon out">↑</div>
          </div>
        </div>

        <div class="transactionHistory-scroll">
          <div class="sm-title" *ngIf="showNoTransactionsLabel">
            {{noTransactionsLabelText}}
          </div>
          <div class="table-list">
            <div class="row" *ngFor="let t of filteredTransactions()"
              (click)="openTransaction(t)">
              <div class="tx-left">
                <div class="tx-icon">
                  <img
                    [src]="'assets/images/' + t.icon"
                    class="tx-img">
                </div>
                <div class="tx-details">
                  <div class="tx-title">
                    {{ t.description }}
                  </div>
                  <div class="tx-date">
                    {{ t.date }}, {{t.status}}
                  </div>
                  <div class="tx-number">
                    {{ t.summaryDisplay }}
                  </div>
                </div>
              </div>
              <div
  class="pill"
  [class.unsuccessful-amount]="t.status === 'Unsuccessful'">
  {{ t.totalAmount }}
</div>
            </div>
          </div>
        </div>
      </div>

      <!-- TRANSACTION DETAILS -->
      <div *ngIf="selectedTransaction">
        <div class="back-btn"
            (click)="selectedTransaction = null">
          ←
        </div>
        <div class="transactionDetails-title">
          Transaction Details ({{selectedTransaction.transactionReference}})
        </div>
        <div class="transactionDetails-scroll">
          <div class="transactionDetails-card">
            <div class="detail-row" *ngIf="selectedTransaction.date">
              <div class="label">Date</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.date}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.status">
              <div class="label">Status</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.status}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.transactionType">
              <div class="label">Type</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.transactionType}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.paymentMethod">
              <div class="label">Payment Method</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.paymentMethod}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.beneficiary">
              <div class="label">Beneficiary</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.beneficiary}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.bankAccount">
              <div class="label">Bank Account</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.bankAccount}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.referenceNumber">
              <div class="label">Reference Number</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.referenceNumber}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.payer">
              <div class="label">Payer</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.payer}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.product">
              <div class="label">Product</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.product}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.pin">
              <div class="label">Pin</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.pin}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.voucherID">
              <div class="label">Voucher ID</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.voucherID}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.electricityMeter">
              <div class="label">Meter</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.electricityMeter}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.creditToken">
              <div class="label">Credit Token</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.creditToken}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.fbeToken">
              <div class="label">FBE Token</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.fbeToken}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.krn1Token">
              <div class="label">KRN1 Token</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.krn1Token}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.krn2Token">
              <div class="label">KRN2 Token</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.krn2Token}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.amount">
              <div class="label">{{selectedTransaction.amountLabel}}</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.amount}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.serviceFee">
              <div class="label">Service Fee</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.serviceFee}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.totalAmount">
              <div class="label">{{selectedTransaction.totalAmountDescription}}</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.totalAmount}}</div>
            </div>
            <div class="detail-row" *ngIf="selectedTransaction.amountRefunded">
              <div class="label">Amount Refunded</div>
              <div class="colon"></div>
              <div class="value">{{selectedTransaction.amountRefunded}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Ok
          </button>
        </div>
      </div>
    </div>
  `
})
export class TransactionsHistoryComponent{
  sessionToken = '';
  userId = '';
   loginKey = ''
    whatsAppUrl = environment.whatsapp_url;
    isLoadingPageContent = true;
    showPageContent = false;
    showErrorPopup = false;
    errorMessage = '';
    transactionMonths: any[] = [];
    transactions: any[] = [];
    selectedMonth = this.transactionMonths[2];
    tab='buy';
    //month='May';

    constructor(private router: Router, 
                private transactionService: TransactionService,
                private sessionService: SessionService) {}

    ngOnInit() {
      this.sessionToken = this.sessionService.getSession();
      if (!this.sessionToken) {
        this.errorMessage = 'Request failed, please reload page and try again.';
        this.showErrorPopup = true;
        
        return;
      }
      this.getTransactionHistory();
    }
    getTransactionHistory() {
      this.transactionService
      .getTransactionHistory(this.sessionToken)
      .subscribe({
          next: response => {
            this.sessionService.setWalletBlance(response.walletBalance);
            this.transactionMonths = response.transactionHistory.transactionMonths.$values;

            this.transactions =  response.transactionHistory.transactionHistory.$values;

            if (this.transactionMonths.length > 0) {
              this.selectedMonth = this.transactionMonths[this.transactionMonths.length - 1];
              this.selectMonth(this.selectedMonth);
            }
            this.isLoadingPageContent = false;
            this.showPageContent = true;
          },
          error: err => {
            if (err.status === 401 || err.status === 404) {
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
            this.isLoadingPageContent = false;
          }
        },
      );
    }
  // =====================================================
  // 
  // =====================================================

  showNoTransactionsLabel = false;
  moneyIn = 0.0;
  moneyOut = 0.0
  
  noTransactionsLabelText = `No transactions made in ${this.selectedMonth}`;
  filteredTransactions() {
    return this.transactions.filter(
      t => t.month === this.selectedMonth
    );
  }
  selectMonth(selectedMonth:any){
    this.selectedMonth = selectedMonth.month;
      const filtered = this.transactions.filter(
      t => t.month === selectedMonth.month
    );

    this.showNoTransactionsLabel = filtered.length === 0;
    this.noTransactionsLabelText = `No transactions made in ${selectedMonth.month}`;

    this.moneyIn = selectedMonth.moneyIn;
    this.moneyOut = selectedMonth.moneyOut;
  }
   selectedTransaction:any = null;
  openTransaction(transaction:any){
    this.selectedTransaction = transaction;
  }
}